enum EViewType {
  ListView = 0,
  ContentView = 1,
  ThumbnailView = 2,
  DetailView = 3,
}

export default EViewType;
